import _ from 'lodash';
import httpClient from '@/core/http/client.service';

const getAllDrugs = () => httpClient.get('api/v1/drug?_format=json');
const getAllFavouritesInfo = () => httpClient.get('api/v1/favourites?_format=json');

const deleteFavourite = (data) => httpClient.post('api/v1/favourites/remove?_format=json', data);

const getDrugInfo = (name) => httpClient.post('api/v1/drug-presentation?_format=json', {
  reference: 'getDrugInfo',
  drug1_name: name,
  type: 'PS',
})
  .then((res) => {
    const drug = res.data.drug1;
    let result = {};

    result = {
        maxdose: drug.drug1_maxdose,
        maxdoseUoms: drug.drug1_uoms_options,
        maxdoseUom: _.values(drug.drug1_uoms_options)[0],
        id: _.keys(drug.drug1_options)[0],
        name: _.values(drug.drug1_options)[0],
        stability_data: drug.drug1_stability_data,
    };


    if (typeof res.data.drug2 !== 'undefined') {
        result.drug2 = {
            maxdose: res.data.drug2.drug2_maxdose,
            maxdoseUom: res.data.drug2.drug2_maxdose_uom,
            id: _.keys(res.data.drug2.drug2_options)[0],
            name: _.values(res.data.drug2.drug2_options)[0],
            stability_data: res.data.drug2.drug2_stability_data,
        };
    }

    if (res.data.drug2) {
        result.drug2 = res.data.drug2;
    }

    return result;
});

const getDrugRouteAdministrations = (data) => httpClient.post('api/v1/drug-presentation?_format=json', data)
  .then((res) => res.data.admin_route_options);

const getDrugContainerTypes = (data) => httpClient.post('api/v1/drug-presentation?_format=json', data)
  .then((res) => res.data.container_options);

const getDrugDiluents = (data) => httpClient.post('api/v1/drug-presentation?_format=json', data);

const getDrugContainerDescs = (data) => httpClient.post('api/v1/drug-presentation?_format=json', data)
  .then((res) => res.data.container_description_options);

const getDrugAncillaries = (data) => httpClient.post('api/v1/drug-presentation?_format=json', data)
  .then((res) => res.data.ancillary_options);

const deleteDrugFromOrder = (data) => httpClient.post('/api/v1/order/drug/remove?_format=json', data);


// refactor
const basicDrugInfo = (data) => httpClient.post('api/v1/drug-presentation?_format=json', data);

const getAllTPNProducts = () => httpClient.get('api/v1/tpn/products?_format=json');
const getTPNProductInfo = (data) => httpClient.post('api/v1/tpn/products?_format=json', data);


export default {
  getAllDrugs,
  getAllFavouritesInfo,
  deleteFavourite,
  getDrugInfo,
  getDrugRouteAdministrations,
  getDrugContainerTypes,
  getDrugDiluents,
  getDrugContainerDescs,
  getDrugAncillaries,
  deleteDrugFromOrder,
  basicDrugInfo,
  getAllTPNProducts,
  getTPNProductInfo,
};
